import React from "react";
import css from "./index.module.css";

const Timeline = ({ data }) => {
  const items = Array.isArray(data) ? [...data].reverse() : [];

  if (!items.length) {
    return null;
  }

  return (
    <div className={css.timeline}>
      {items.map((item, index) => (
        <div
          className={`${css.item} ${
            item && item.color && typeof item.color === "string" && !item.color.startsWith("#") && !item.color.startsWith("rgb") && !item.color.startsWith("hsl")
              ? css[`variant_${item.color}`] || css.variant_default
              : css.variant_default
          }`}
          key={index}
        >
          <div className={css.markerColumn}>
            <div
              className={css.marker}
              style={
                item && item.color && typeof item.color === "string" && (item.color.startsWith("#") || item.color.startsWith("rgb") || item.color.startsWith("hsl"))
                  ? { backgroundColor: item.color }
                  : undefined
              }
            />
            {index !== items.length - 1 && (
              <div
                className={css.line}
                style={
                  item && item.color && typeof item.color === "string" && (item.color.startsWith("#") || item.color.startsWith("rgb") || item.color.startsWith("hsl"))
                    ? { backgroundColor: item.color }
                    : undefined
                }
              />
            )}
          </div>
          <div className={css.content}>
            <div className={css.headerRow}>
              <span
                className={css.status}
                style={
                  item && item.color && typeof item.color === "string" && (item.color.startsWith("#") || item.color.startsWith("rgb") || item.color.startsWith("hsl"))
                    ? { borderColor: item.color, color: item.color }
                    : undefined
                }
              >
                {item.status}
              </span>
              <span className={css.date}>{item.date}</span>
            </div>
            <div className={css.title}>{item.title}</div>
            {item.description && (
              <div className={css.description}>{item.description}</div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Timeline;

